import styles from "./upsc-environment-book.module.css";
import Link from "next/link";
import ReCAPTCHA from "react-google-recaptcha";
import { useState } from "react";
import { createuser } from "../../components/Service/EnvironmentBook";
import dynamic from 'next/dynamic';
const Otpverification = dynamic(()=>import("../../components/Modal/Otpverification"));

const UPSC_environment_book_Form = () => {
  const [verified, setverified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOtp, setModalOtp] = useState(false);
  const [modalOtpstatus, setmodalOtpstatus] = useState(null);
  const [modalOtpExceptionMessage, setmodalOtpExceptionMessage] = useState('');
  const [valuephno, setvaluephno] = useState(undefined);
  const [captchaerror, setcaptchaerror] = useState(undefined);


  function convertJsonStringToNumber(jsonString) {
    // Parse the JSON string to an object
    const jsonObject = JSON.parse(jsonString);
  
    // Iterate over the keys and convert numeric strings to numbers
    for (const key in jsonObject) {
      if (jsonObject.hasOwnProperty(key)
&& !isNaN(jsonObject[key])) {
        jsonObject[key] = Number(jsonObject[key]);
      }
    }
  
    return jsonObject;
  }
  function onChange(value) {
    if (value == null) {
      setverified(false);
    }
    else {
      setverified(true);
    }
  }
  

  async function handleOnSubmit(e) {
    e.preventDefault();
    if (verified) {
      const formData = {};
      formData["formType"] = "Environmentbook";
      formData['title'] = "UPSC Environment Book";

      Array.from(e.currentTarget.elements).forEach((field) => {
        if (!field.name) return;
        formData[field.name] = field.value;
      });
      //formData['countryCode'] = "+91";
      formData['phoneNo'] = formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
      formData['phoneNo'] = convertJsonStringToNumber(formData['phoneNo']);
          const transform={fields:{...formData}};
          console.log(transform);


          setIsLoading(true);
          createuser(transform)
              .then(response => {
                 
                  setModalOtp(true);
                  setmodalOtpstatus(response.message);
                  window.grecaptcha.reset(setverified);
                  setverified(false);
                  setvaluephno(undefined);
                  document.getElementById("Environmentbook").reset();
                  setIsLoading(false);
              })

        .catch(error => {
          setModalOtp(true);
          setmodalOtpstatus("failure");
          window.grecaptcha.reset(setverified);
          setverified(false);
          setIsLoading(false);
        })

    }
    else {
      setcaptchaerror(true);
      setTimeout(() => {
        setcaptchaerror(false);
      }, 3000);
    }
  }

  return (
    <>

      {isLoading &&
        <div class="APIPreLoader" id="APIPreLoader">
          <div class="loader">Loading...</div>
        </div>
      }

      <Otpverification show={modalOtp} title={modalOtpstatus} method="POST" action="index.js" frompage= "Environmentbook" onHide={() => setModalOtp(false)} />
      <div className=" pt-3">
        {/* <div className="row pt-3"> */}

          <div className="container pt-4 ">
            <div className="row">
              <p className={`${styles.contactheader}`}>Delivery Details</p>
            </div>

            <div className="row">

              <div className="col">

                <form onSubmit={handleOnSubmit} id="Environmentbook" autoComplete="off" action="makepayment.js">

                  <div className="row pt-4">

                    <div className="col-12">
                      <div className="mb-4">
                        <input type="text" className={`${styles.acheiverrank} form-control`} placeholder="Name" autoComplete="off" name="name" pattern="[A-Za-z]{3,}" minLength="1" required />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="mb-4">
                        <input type="email" className={`${styles.acheiverrank} form-control`} placeholder="Email Address" title="Please enter a valid email address" autoComplete="off" name="emailAddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="mb-4">
                        <input type="tel" className={`${styles.acheiverrank} form-control`} name="phoneNo" placeholder="Phone No" pattern="[0-9]{10}" maxlength="10" required />
                      </div>
                    </div>

                    <div className="col-12 ">
                      <div className="mb-4">
                      <textarea type="text" className={`${styles.acheiverrank} form-control`} name="address" placeholder="Address"  rows="4" minlength="10" required />
                      </div>
                    </div>

                  </div>
                 
                  <div className="d-flex flex-wrap mb-3">
                    <div className="me-3 mt-2">
                      <ReCAPTCHA className={`${styles.captcha}`}
                        sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"
                        onChange={onChange}
                      />
                      <div className="">
                        {captchaerror && <div className="text-danger text-center captachafont">Please verify the captcha!</div>}
                      </div>
                    </div>
                    <div className="my-auto">
                      <p className="mt-3"><button className={`${styles.normalbutton}`} type="submit" > Send OTP</button></p>
                    
                     </div>
                  </div>


                </form>

              </div>

            </div>

          </div>

        {/* </div> */}
      </div>


      

    </>
  )
}
export default UPSC_environment_book_Form;